import React from "react";
import dayjs from "dayjs";

const ClockModal = ({ open, handleClose, obj }) => {
  if (!open) return null;
  console.log("obj",obj);
  

  const BASE_URL = "/onboarding/emp_timesheets";

  const clockInImage = obj?.clockin_pic ? `${BASE_URL}/${obj.clockin_pic}` : null;
  const clockOutImage = obj?.clockout_pic ? `${BASE_URL}/${obj.clockout_pic}` : null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-11/12 sm:w-[700px] relative p-8">
        {/* ❌ Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold"
        >
          &times;
        </button>

        {/* Header */}
        <h2 className="text-xl font-semibold text-[#1D2951] text-center mb-8">
          Employee Time Details
        </h2>

        {/* Images and Times */}
        <div className="flex flex-col sm:flex-row justify-around items-center gap-10">
          {/* Clock In */}
          <div className="flex flex-col items-center text-center">
            <h3 className="text-lg font-medium text-gray-800 mb-3">Clock In</h3>

            {clockInImage ? (
              <img
                src={clockInImage}
                alt="Clock In"
                className="w-48 h-48 object-cover rounded-lg border border-gray-200 shadow-sm mb-3"
              />
            ) : (
              <div className="w-48 h-48 flex items-center justify-center border border-gray-200 rounded-lg text-gray-400 text-lg mb-3">
                --
              </div>
            )}

            <span className="text-sm text-gray-600">
              {obj?.clockin_pic_time
                ? dayjs(obj.clockin_pic_time).format("hh:mm A, DD MMM YYYY")
                : "--"}
            </span>
          </div>

          {/* Clock Out */}
          <div className="flex flex-col items-center text-center">
            <h3 className="text-lg font-medium text-gray-800 mb-3">Clock Out</h3>

            {clockOutImage ? (
              <img
                src={clockOutImage}
                alt="Clock Out"
                className="w-48 h-48 object-cover rounded-lg border border-gray-200 shadow-sm mb-3"
              />
            ) : (
              <div className="w-48 h-48 flex items-center justify-center border border-gray-200 rounded-lg text-gray-400 text-lg mb-3">
                --
              </div>
            )}

            <span className="text-sm text-gray-600">
              {obj?.clockout_pic_time
                ? dayjs(obj.clockout_pic_time).format("hh:mm A, DD MMM YYYY")
                : "--"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClockModal;
